// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.delete-button,
.add-button {
  width: 2.4rem;
  height: 2.4rem;
  border-radius: 50%;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 2rem;
}

.delete-button {
  background-color: #fee2e2;
  color: #dc2626;
  margin-left: auto;
  min-width: 2.4rem;
  min-height: 2.4rem;
  max-width: 2.4rem;
  max-height: 2.4rem;
  flex-shrink: 0;
  box-sizing: border-box;
}

.delete-button.loading {
  width: 2.4rem;
  height: 2.4rem;
  min-width: 2.4rem;
  min-height: 2.4rem;
  max-width: 2.4rem;
  max-height: 2.4rem;
}

.delete-button.loading .button-loader {
  border-color: #dc2626;
  border-top-color: transparent;
}

.add-button {
  background-color: #dcfce7;
  color: #16a34a;
  width: 2.4rem;
  height: 2.4rem;
  min-width: 2.4rem;
  min-height: 2.4rem;
  max-width: 2.4rem;
  max-height: 2.4rem;
  border-radius: 50%;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 2rem;
  position: relative;
  flex-shrink: 0;
  box-sizing: border-box;
}

.add-button:disabled {
  cursor: not-allowed;
  opacity: 0.7;
}

.button-loader {
  width: 1.6rem;
  height: 1.6rem;
  border: 2px solid #16a34a;
  border-top: 2px solid transparent;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

/* Animation pour le loader circulaire */
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* Styles spécifiques pour les différents états de loading */
.add-button.loading {
  background-color: #dcfce7;
  color: transparent; /* Cache le texte pendant le chargement */
  width: 2.4rem;
  height: 2.4rem;
  min-width: 2.4rem;
  min-height: 2.4rem;
  max-width: 2.4rem;
  max-height: 2.4rem;
}

.add-section .add-button.loading .button-loader {
  border-color: #16a34a;
  border-top-color: transparent;
}

/* Pour le bouton d'ajout d'article dans la ligne */
.add-article .add-button.loading .button-loader {
  border-color: #16a34a;
  border-top-color: transparent;
}

.sections-container {
  margin: 2rem 0;
}

.add-section {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 2rem;
}

.add-section input {
  padding: 1rem;
  width: 300px;
}

.section {
  margin-bottom: 2rem;
  border: 1px solid #e5e7eb;
  border-radius: 1rem;
  overflow: hidden;
}

.articles-list {
  padding: 1.2rem;
}

.article-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  border-bottom: 1px solid #e5e7eb;
}

.article-item:last-child {
  border-bottom: none;
}

.add-article {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-top: 1rem;
}

.add-article input {
  padding: 1rem;
  width: 95%;
}

.add-article-button {
  width: 100%;
  padding: 1rem;
  background: none;
  border: 2px dashed #e5e7eb;
  border-radius: 0.4rem;
  color: #6b7280;
  cursor: pointer;
  margin-top: 1rem;
}

.add-article-button:hover {
  border-color: #da7027;
  color: #da7027;
}

.numero-article {
  width: 10rem;
}

.add-section h3 {
  font-size: 1.6rem;
}

.creation-article {
  display: flex;
  justify-content: space-between;
  gap: 2rem;
}

.creation-article p {
  width: 95%;
}

.loader {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #da7027;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
  margin: 0 auto;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.titre-article {
  display: flex;
  justify-content: space-between;
  background-color: rgba(194, 194, 194, 0.5);
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  padding: 1rem;
  color: #2c3948;
}

/* Ajustements pour le mode consultation des articles */
.view-mode .section {
  margin-bottom: 2rem;
}

.view-mode .section-header {
  display: flex;
  align-items: center;
}

.view-mode .section-header h3 {
  font-size: 1.6rem;
  margin: 0;
}

.empty-sections-message {
  padding: 2rem;
  background-color: #f3f4f6;
  border-radius: 0.5rem;
  text-align: center;
}

.step-container {
  padding: 2rem;
}

.step-container h2 {
  font-size: 2.4rem;
  margin-bottom: 4rem;
  text-align: center;
}

.article-container.article-selected {
  background-color: #f5f5f5;
  opacity: 0.8;
}

.article-container.article-selected .article-row {
  background-color: #f0f0f0;
}
`, "",{"version":3,"sources":["webpack://./src/composants/CreationArticle/CreationArticle.css"],"names":[],"mappings":"AAAA;;EAEE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,cAAc;EACd,yBAAyB;EACzB,iCAAiC;EACjC,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA,wCAAwC;AACxC;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,4DAA4D;AAC5D;EACE,yBAAyB;EACzB,kBAAkB,EAAE,yCAAyC;EAC7D,aAAa;EACb,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA,mDAAmD;AACnD;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,0BAA0B;EAC1B,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,0CAA0C;EAC1C,4BAA4B;EAC5B,6BAA6B;EAC7B,aAAa;EACb,cAAc;AAChB;;AAEA,uDAAuD;AACvD;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".delete-button,\n.add-button {\n  width: 2.4rem;\n  height: 2.4rem;\n  border-radius: 50%;\n  border: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  font-size: 2rem;\n}\n\n.delete-button {\n  background-color: #fee2e2;\n  color: #dc2626;\n  margin-left: auto;\n  min-width: 2.4rem;\n  min-height: 2.4rem;\n  max-width: 2.4rem;\n  max-height: 2.4rem;\n  flex-shrink: 0;\n  box-sizing: border-box;\n}\n\n.delete-button.loading {\n  width: 2.4rem;\n  height: 2.4rem;\n  min-width: 2.4rem;\n  min-height: 2.4rem;\n  max-width: 2.4rem;\n  max-height: 2.4rem;\n}\n\n.delete-button.loading .button-loader {\n  border-color: #dc2626;\n  border-top-color: transparent;\n}\n\n.add-button {\n  background-color: #dcfce7;\n  color: #16a34a;\n  width: 2.4rem;\n  height: 2.4rem;\n  min-width: 2.4rem;\n  min-height: 2.4rem;\n  max-width: 2.4rem;\n  max-height: 2.4rem;\n  border-radius: 50%;\n  border: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  font-size: 2rem;\n  position: relative;\n  flex-shrink: 0;\n  box-sizing: border-box;\n}\n\n.add-button:disabled {\n  cursor: not-allowed;\n  opacity: 0.7;\n}\n\n.button-loader {\n  width: 1.6rem;\n  height: 1.6rem;\n  border: 2px solid #16a34a;\n  border-top: 2px solid transparent;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n/* Animation pour le loader circulaire */\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n/* Styles spécifiques pour les différents états de loading */\n.add-button.loading {\n  background-color: #dcfce7;\n  color: transparent; /* Cache le texte pendant le chargement */\n  width: 2.4rem;\n  height: 2.4rem;\n  min-width: 2.4rem;\n  min-height: 2.4rem;\n  max-width: 2.4rem;\n  max-height: 2.4rem;\n}\n\n.add-section .add-button.loading .button-loader {\n  border-color: #16a34a;\n  border-top-color: transparent;\n}\n\n/* Pour le bouton d'ajout d'article dans la ligne */\n.add-article .add-button.loading .button-loader {\n  border-color: #16a34a;\n  border-top-color: transparent;\n}\n\n.sections-container {\n  margin: 2rem 0;\n}\n\n.add-section {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  margin-bottom: 2rem;\n}\n\n.add-section input {\n  padding: 1rem;\n  width: 300px;\n}\n\n.section {\n  margin-bottom: 2rem;\n  border: 1px solid #e5e7eb;\n  border-radius: 1rem;\n  overflow: hidden;\n}\n\n.articles-list {\n  padding: 1.2rem;\n}\n\n.article-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1rem;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.article-item:last-child {\n  border-bottom: none;\n}\n\n.add-article {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  margin-top: 1rem;\n}\n\n.add-article input {\n  padding: 1rem;\n  width: 95%;\n}\n\n.add-article-button {\n  width: 100%;\n  padding: 1rem;\n  background: none;\n  border: 2px dashed #e5e7eb;\n  border-radius: 0.4rem;\n  color: #6b7280;\n  cursor: pointer;\n  margin-top: 1rem;\n}\n\n.add-article-button:hover {\n  border-color: #da7027;\n  color: #da7027;\n}\n\n.numero-article {\n  width: 10rem;\n}\n\n.add-section h3 {\n  font-size: 1.6rem;\n}\n\n.creation-article {\n  display: flex;\n  justify-content: space-between;\n  gap: 2rem;\n}\n\n.creation-article p {\n  width: 95%;\n}\n\n.loader {\n  border: 4px solid #f3f3f3;\n  border-top: 4px solid #da7027;\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n  animation: spin 1s linear infinite;\n  margin: 0 auto;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.titre-article {\n  display: flex;\n  justify-content: space-between;\n  background-color: rgba(194, 194, 194, 0.5);\n  border-top-left-radius: 10px;\n  border-top-right-radius: 10px;\n  padding: 1rem;\n  color: #2c3948;\n}\n\n/* Ajustements pour le mode consultation des articles */\n.view-mode .section {\n  margin-bottom: 2rem;\n}\n\n.view-mode .section-header {\n  display: flex;\n  align-items: center;\n}\n\n.view-mode .section-header h3 {\n  font-size: 1.6rem;\n  margin: 0;\n}\n\n.empty-sections-message {\n  padding: 2rem;\n  background-color: #f3f4f6;\n  border-radius: 0.5rem;\n  text-align: center;\n}\n\n.step-container {\n  padding: 2rem;\n}\n\n.step-container h2 {\n  font-size: 2.4rem;\n  margin-bottom: 4rem;\n  text-align: center;\n}\n\n.article-container.article-selected {\n  background-color: #f5f5f5;\n  opacity: 0.8;\n}\n\n.article-container.article-selected .article-row {\n  background-color: #f0f0f0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
